import { Component, computed, inject } from '@angular/core';
import { LanguageService } from '../../service/language.service';
import { TrackingService } from '../../service/tracking.service';

const TEXTS = {
  fr: {
    message: 'Cookie publicitaire Meta : il nous indique quelles publicités amènent des demandes de devis.',
    accept: 'Accepter',
    refuse: 'Refuser',
    label: 'Cookies publicitaires',
  },
  en: {
    message: 'Meta advertising cookie: it tells us which ads bring quote requests.',
    accept: 'Accept',
    refuse: 'Refuse',
    label: 'Advertising cookies',
  },
};

/** Asks once before the Meta Pixel loads. Both answers are remembered. */
@Component({
  selector: 'app-consent-banner',
  template: `
    @if (visible()) {
      <aside class="consent" role="region" [attr.aria-label]="text().label">
        <p>{{ text().message }}</p>
        <div class="consent__actions">
          <button type="button" class="consent__btn" (click)="tracking.setConsent('denied')">{{ text().refuse }}</button>
          <button type="button" class="consent__btn consent__btn--accept" (click)="tracking.setConsent('granted')">{{ text().accept }}</button>
        </div>
      </aside>
    }
  `,
  styles: `
    .consent {
      position: fixed;
      z-index: 60;
      inset: auto 0 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: .75rem;
      padding: .5rem .75rem;
      padding-bottom: calc(.5rem + env(safe-area-inset-bottom));
      background: #fff;
      border-top: 1px solid var(--mat-sys-outline-variant);
      box-shadow: 0 -8px 24px -16px rgb(0 0 0 / .35);
      color: var(--mat-sys-on-surface);
      font-size: .75rem;
      line-height: 1.3;
    }
    /* On a phone the bottom of the screen holds the quote form's buttons, so the banner
       goes over the site header instead: it hides the logo and menu, never the form. */
    @media (max-width: 767px) {
      .consent {
        inset: 0 0 auto 0;
        min-height: 4rem;
        padding-top: calc(.5rem + env(safe-area-inset-top));
        padding-bottom: .5rem;
        border-top: 0;
        border-bottom: 1px solid var(--mat-sys-outline-variant);
        box-shadow: 0 8px 24px -16px rgb(0 0 0 / .35);
      }
    }
    p { margin: 0; flex: 0 1 auto; min-width: 0; }
    .consent__actions { display: flex; flex: none; gap: .375rem; }
    /* Same size and weight for both answers: refusing must be as easy as accepting. */
    .consent__btn {
      min-height: 2.25rem;
      padding: 0 .75rem;
      border: 1px solid var(--mat-sys-primary);
      border-radius: 999px;
      background: #fff;
      color: var(--mat-sys-primary);
      font: inherit;
      font-weight: 600;
      cursor: pointer;
    }
    .consent__btn--accept { background: var(--mat-sys-primary); color: var(--mat-sys-on-primary); }
    .consent__btn:focus-visible { outline: 2px solid var(--mat-sys-primary); outline-offset: 2px; }
  `,
})
export class ConsentBannerComponent {
  readonly tracking = inject(TrackingService);
  private langService = inject(LanguageService);

  readonly text = computed(() => TEXTS[this.langService.currentLang()]);
  readonly visible = computed(() => this.tracking.consent() === null && !TrackingService.isPrivatePage());
}
